import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "preference" }
const _hoisted_2 = {
  key: 0,
  class: "preference-title inactive"
}
const _hoisted_3 = { class: "preference-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Date:", -1)
const _hoisted_5 = { class: "day-carousel" }
const _hoisted_6 = {
  slot: "button-prev",
  class: "swiper-button-prev"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "month" }
const _hoisted_9 = { class: "day-number" }
const _hoisted_10 = { class: "day-name" }
const _hoisted_11 = {
  slot: "button-next",
  class: "swiper-button-next"
}
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = { class: "col" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "text-muted" }, "Time:", -1)
const _hoisted_15 = { class: "row times" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 2,
  class: "time-chosen d-flex justify-content-between"
}
const _hoisted_18 = { class: "text-primary text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.active === false)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : (_ctx.isNullish(_ctx.dayTimePreference))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", _hoisted_6, [
                _createVNode(_component_icon, { icon: ['far', 'chevron-left'] })
              ]),
              _createVNode(_component_swiper, {
                ref: "swiper",
                class: "days",
                options: _ctx.swiperOption,
                "slides-per-view": 2,
                navigation: _ctx.swiperOption.navigation
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, {
                      key: `day-${index}`,
                      class: "day"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass({
                active: _ctx.activeDay(day)
              }),
                          onClick: ($event: any) => (_ctx.selectDay(day))
                        }, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(day.format('MMM')), 1),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(day.format('DD')), 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(day.format('ddd')), 1)
                        ], 10, _hoisted_7)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["options", "navigation"]),
              _createElementVNode("button", _hoisted_11, [
                _createVNode(_component_icon, { icon: ['far', 'chevron-right'] })
              ])
            ]),
            (_ctx.selectedDay)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("section", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDayTimes, (dayTime, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${index}-dayTime`,
                          class: "col-md-3 col-4"
                        }, [
                          _createElementVNode("button", {
                            class: _normalizeClass([{
                  active: _ctx.activeTime(dayTime.slotTitle)
                }, "drop-off-time"]),
                            onClick: ($event: any) => (_ctx.selectSlot(dayTime))
                          }, _toDisplayString(dayTime.slotTitle), 11, _hoisted_16)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.formattedTimePreference), 1),
            _createElementVNode("button", {
              class: "btn btn-outline-secondary btn-sm",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetPreference && _ctx.resetPreference(...args)))
            }, "Change time")
          ]))
  ]))
}